import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import PrivacyPolicy from 'src/views/PrivacyPolicy';
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true,
    isIncidental: true
  }
}));
export default PrivacyPolicy;